module.exports = __webpack_public_path__ + "static/img/about-1-Overview-img-8.487bb38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about-1-Overview-img-8.jpg
// module id = SGRk
// module chunks = 0